import React, { useState, useEffect } from 'react';
import {Form, Modal, notification, Select, SelectProps, Input} from 'antd';
import { IAnswerEditModal, TServiceUrl } from '../express-help.types';
import Button from '/react4xp/mixins/ui/button/button';
import {getQuestionsByQuestionnaireId, getResultList, updateAnswer} from "/react4xp/parts/express-help/actions";

const filterOptionByLabel = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

const AnswerEditModal = (props: IAnswerEditModal) => {
    const { selectedObject } = props;

    const [results, setResults] = useState<SelectProps['options']>([]);
    const [questions, setQuestions] = useState<SelectProps['options']>([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [form] = Form.useForm();

    const onFinish = () => {
        form.validateFields().then(() => {
            if (selectedObject) {
                setIsSaving(true);

                updateAnswer(selectedObject.id, {
                    ...selectedObject,
                    ...form.getFieldsValue()
                })
                    .then(() => {
                        notification['success']({
                            message: 'Данные обновлены!',
                        });
                        props.handleOk();
                    })
                    .finally(
                        () => setIsSaving(false)
                    );
            }
        });
    };

    const handleCancel = () => {
        props.handleCancel();
    };

    useEffect(() => {
        Promise.all([
            getResultList(),
            getQuestionsByQuestionnaireId(props.questionnaireId)

        ]).then(
            ([result, question]) => {
                if (result) {
                    setResults(result.data);
                }

                if (question) {
                    setQuestions(question.data.content);
                }
            }
        ).finally(
            () => setIsLoading(false)
        );
    }, []);

    useEffect(() => {
        if (selectedObject) {
            form.setFieldsValue(selectedObject);
        }
    }, [selectedObject]);

    return (
        <Modal
            title="Редактирование ответа"
            open={props.isModalOpen}
            onCancel={handleCancel}
            destroyOnClose={true}
            footer={[
                <Button onClick={handleCancel}>Отмена</Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={onFinish}
                    color="gold"
                    loading={isSaving}
                >
                    Сохранить
                </Button>,
            ]}
        >
            <div>
                <Form
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        name="answerKk"
                        label="Ответ на казахском языке"
                    >
                        <Input placeholder="Введите" />
                    </Form.Item>
                    <Form.Item
                        name={'answerRu'}
                        label={'Ответ на русском языке'}
                    >
                        <Input placeholder="Введите"/>
                    </Form.Item>
                    <Form.Item
                        name={'answerEn'}
                        label={'Ответ на английском языке'}
                    >
                        <Input placeholder="Введите" />
                    </Form.Item>
                    <Form.Item
                        name="resultIds"
                        label="Результат"
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Select
                            mode="multiple"
                            showSearch
                            placeholder={'Выберите'}
                            notFoundContent={<p>не найдено</p>}
                            defaultValue={
                                selectedObject &&
                                selectedObject.resultIds &&
                                selectedObject.resultIds
                            }
                            filterOption={filterOptionByLabel}
                            options={(results || []).map((d) => ({
                                value: d.id,
                                label: d.resultRu,
                            }))}
                        />
                    </Form.Item>
                    <Form.Item
                        name="nextQuestionId"
                        label="Добавочный вопрос"
                    >
                        <Select
                            showSearch
                            placeholder={'Выберите'}
                            notFoundContent={<p>не найдено</p>}
                            defaultValue={
                                selectedObject &&
                                selectedObject.nextQuestionId &&
                                selectedObject.nextQuestionId
                            }
                            filterOption={filterOptionByLabel}
                            options={(questions || []).map((d) => ({
                                value: d.id,
                                label: d.questionRu,
                            }))}
                        />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default AnswerEditModal;
